import Vue from 'vue';

export const resizeSelf = Vue.directive('resizeSelf', {
    inserted(el: HTMLElement, binding: any) {
        let height = el.clientHeight;
        let width = el.clientWidth;

        binding.value?.({ width, height });

        const observer = new ResizeObserver((entries: ResizeObserverEntry[]) => {
            const entry = entries[0];
            if (entry && (entry.target.clientWidth !== width || entry.target.clientHeight !== height)) {
                width = entry.target.clientWidth;
                height = entry.target.clientHeight;
                binding.value?.({ width, height });
            }
        });

        observer.observe(el);
    },
});
